export  const BASE_URL_PRO="http://braun-api-bridge.jinshiyouxuan.com:88/"
/*  const BASE_URL_PRO= "http://test-hsz.xingpinmao.com/i/"
  const BASE_URL_DEV="http://test-hsz.xingpinmao.com/"
export const CommonTagTypeUserInfo  = 1 //用户资讯标签*/
export const IMAGE_UPLOAD_LOCAL_URL = "/i/admin/system/upload/local" //上传到服务器本地
export const IMAGE_UPLOAD_WEB3_STORAGE_URL = "/i/admin/system/upload/web3_storage" //上传到服务器本地
export const IMAGE_UPLOAD_OSS_URL = "/i/admin/system/upload" //上传到服务器 oss服务
export const IMAGE_UPLOAD_PRO_URL =IMAGE_UPLOAD_LOCAL_URL //正式环境 上传到服务器

export const CommonTagTypeUserInfo  = 1 //用户资讯标签
export const CommonTagTypeUserHobby = 2 //用户喜好标签
export const CommonTagTypeGoods     = 10//商品标签
export const CommonTagTypeAdmin     = 20//管理员标签
//标签 类型
  export const CommonTagTypeDict      = {
      0: "未分类",
      1: "用户资讯标签",
      2: "用户喜好标签",
      10: "商品标签",
      20: "管理员标签",
}
//标签 类型
export function CommonTagTypeMap(typers) {
     let cateStr= CommonTagTypeDict[typers]
    if (cateStr==null ||cateStr===""){
        cateStr="未分类"
    }
    return cateStr
}

export default { IMAGE_UPLOAD_LOCAL_URL,IMAGE_UPLOAD_OSS_URL,CommonTagTypeUserInfo, CommonTagTypeUserHobby,
    CommonTagTypeGoods, CommonTagTypeAdmin ,
    CommonTagTypeDict,CommonTagTypeMap}

